/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Directive, OnInit} from '@angular/core';
import {NavigationEnd, Router} from "@angular/router";
import {filter} from "rxjs/operators";
import {DomHandler} from "primeng/dom";

@Directive({
  selector: '[wellPreventScrollOnRouterOutlet]'
})
export class PreventScrollOnRouterOutletDirective implements OnInit {

  constructor(private router: Router) {
  }

  ngOnInit() {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event) => {
      if (this.router.url.search(/\s*\(.*?\)\s*/g) != -1) {
        DomHandler.addClass(document.body, 'p-overflow-hidden');
      } else {
        DomHandler.removeClass(document.body, 'p-overflow-hidden');
      }
    });
  }

}
